import Page from 'src/components/page/page';
import { Button, Container, Stack, Tab, Tabs } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import { paths } from 'src/routes/paths';
import useCollectionsList from './collections-list.hook';
import CollectionsTab from './components/collections-tab';
import ReportsTab from './components/reports-tab';
import { useMyDataStore } from 'src/store/me/me.store';

export default function CollectionsList() {
  const { TABS, currentTab, handleChangeTab, navigate, onSelectAllRows, onSelectRow, onExport } =
    useCollectionsList();

  const permission = useMyDataStore((state) => state.me?.cnAdminInfo?.permissions?.benefits.create);

  return (
    <Page title="Lista de Coleções">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading="Lista de Coleções"
          links={[]}
          action={
            <Stack spacing={2} direction="row">
              <Button variant="contained" onClick={() => onExport()}>
                Exportar Planilha
              </Button>
              <Button
                disabled={!permission}
                variant="contained"
                onClick={() => navigate(paths.dashboard.collectionsCreate)}
              >
                Cadastrar Coleção
              </Button>
            </Stack>
          }
        />

        <>
          <Tabs value={currentTab} onChange={handleChangeTab} sx={{ mb: { xs: 2, md: 3 } }}>
            {TABS.map((tab: any) => (
              <Tab
                key={tab.value}
                label={tab.label}
                value={tab.value}
                sx={{ textAlign: 'start', width: 130 }}
              />
            ))}
          </Tabs>
          {currentTab === 'collections' ? (
            <CollectionsTab onSelectAllRows={onSelectAllRows} onSelectRow={onSelectRow} />
          ) : (
            <ReportsTab />
          )}
        </>
      </Container>
    </Page>
  );
}
